import { Modal } from "react-bootstrap";

const ConfirmModal = ({
  show,
  onClose,
  title,
  body,
  closeBtnTitle = "Close",
  submitBtnTitle = "Continue",
  onSubmit,
  loadingOnsubmit,
}) => {
  const handleClose = () => {
    onClose?.();
  };

  return (
    <Modal
      className="modal fade"
      id="kt_modal_select_location"
      data-backdrop="static"
      tabIndex={-1}
      onHide={handleClose}
      role="dialog"
      show={show}
      dialogClassName="modal-dialog-centered"
    >
      <Modal.Header className="fs-5 " closeButton>{title}</Modal.Header>
      <Modal.Body className="overflow-auto">{body}</Modal.Body>
       <Modal.Footer> 
        <button
            type="button"
            onClick={handleClose}
            className="btn btn-md rounded-pill btn-secondary px-4 d-flex align-items-center justify-content-center"
          >
            {closeBtnTitle}
          </button>
          {loadingOnsubmit ? (
            <button
              id="submit"
              type="button"
              className="btn btn-md rounded-pill btn-primary px-4 d-flex align-items-center justify-content-center"
              disabled
            >
              Please wait...
            </button>
          ) : (
            <button
              id="submit"
              onClick={onSubmit}
              type="button"
              className="btn btn-md rounded-pill btn-primary px-4 d-flex align-items-center justify-content-center"
            >
              {submitBtnTitle}
            </button>
          )}</Modal.Footer> 
    </Modal>
  );
};

export { ConfirmModal };
